/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetCashReserveSelfStatus200,
  GetCashReserveSelfStatus400,
  GetCashReserveSelfStatus401,
  GetCashReserveSelfStatus403,
  GetCashReserveSelfStatus500,
} from '../types/GetCashReserveSelf'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getCashReserveSelf } from '../clients/getCashReserveSelf'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getCashReserveSelfQueryKey = () => [{ url: '/v1/accounts/self/cash_reserve' }] as const

type GetCashReserveSelfQueryKey = ReturnType<typeof getCashReserveSelfQueryKey>

export function getCashReserveSelfQueryOptions(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getCashReserveSelfQueryKey()
  return queryOptions<
    GetCashReserveSelfStatus200,
    ResponseErrorConfig<
      | GetCashReserveSelfStatus400
      | GetCashReserveSelfStatus401
      | GetCashReserveSelfStatus403
      | GetCashReserveSelfStatus500
    >,
    GetCashReserveSelfStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getCashReserveSelf({
        ...config,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Returns the user's available Global Account USD balance alongside their minimum cash reserve requirement and its breakdown. While available_usd is below required_usd the user may not open new leveraged positions, submit buy orders, transfer assets out of their Global Account or withdraw.
 * @summary Get the minimum USD cash reserve requirement for the logged in user
 * {@link /v1/accounts/self/cash_reserve}
 */
export function useGetCashReserveSelf<
  TData = GetCashReserveSelfStatus200,
  TQueryData = GetCashReserveSelfStatus200,
  TQueryKey extends QueryKey = GetCashReserveSelfQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetCashReserveSelfStatus200,
        ResponseErrorConfig<
          | GetCashReserveSelfStatus400
          | GetCashReserveSelfStatus401
          | GetCashReserveSelfStatus403
          | GetCashReserveSelfStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getCashReserveSelfQueryKey()

  const queryResult = useQuery(
    {
      ...getCashReserveSelfQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetCashReserveSelfStatus400
      | GetCashReserveSelfStatus401
      | GetCashReserveSelfStatus403
      | GetCashReserveSelfStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
